import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AboutBanner from "../components/AboutBanner";
import ContactSection from "../components/ContactSection";
import SectionAbout from "../components/CmAbout/CMSectionAbout";
import FoundersMessage from "../components/CmAbout/CMFoundersMessage";
import VisionMission from "../components/CmAbout/CMVisionMission";
import TeamSection from "../components/About/TeamSection";
import EndToEndSolutions from "../components/CmAbout/CMEndToEndSolutions";
import ValuesTriangle from "../components/CmAbout/ValuesTriangle";


function Home() {
  return (
    <>
      <Header />
      <AboutBanner
  title="About Us"
  subtitle="☀️ CM Groups – Leading the Future of Innovation"
/>
      <SectionAbout />
      <FoundersMessage />
      <VisionMission />
      <ValuesTriangle />
      <TeamSection />
      <EndToEndSolutions />
      <ContactSection />
      <Footer /> 
    </>
  );
}

export default Home;
